import { useLogout as usePrivyLogout } from '@privy-io/react-auth';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearExternalWalletBalances } from '../redux/slices/walletSlice';
import { useSolana } from './useSolana';
import { setPrivyToken } from '../redux/slices/auth';
import { currentUserApi } from '../redux/api/authorized/auth';
import { authorizedApi } from '../redux/api/authorized';
import { resetWalletBalances } from '../redux/slices/walletSlice';

export const useLogout = (setIsOpen = null) => {
  const { logout } = usePrivyLogout();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { externalWallet } = useSolana();

  const handleDisconnectWallet = async () => {
    if (externalWallet && externalWallet?.disconnect) {
      await externalWallet.disconnect();
      dispatch(clearExternalWalletBalances());
    }
  };

  const handleLogout = async () => {
    // Logout from Privy
    await logout();

    dispatch(setPrivyToken(null));
    dispatch(authorizedApi.util.resetApiState());

    dispatch(resetWalletBalances());
    handleDisconnectWallet();

    // Close dropdown if provided
    if (setIsOpen) {
      setIsOpen(false);
    }

    // Navigate to home page
    navigate('/');
  };

  return { handleLogout, handleDisconnectWallet };
};
